var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-page"},[_c('span',{staticClass:"error-tip"},[_vm._v("404")]),_c('div',[_c('p',[_vm._v("页面走丢了。。。")]),_c('router-link',{attrs:{"to":"/"}},[_c('el-button',{attrs:{"type":"text"}},[_vm._v("返回首页")])],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }